module.exports = __webpack_public_path__ + "img/yuka_MuR.6f5b0e0a.png";